<template>
  <v-dialog
    v-model="dialogOpen"
    attach=".body"
    class="dialog"
    scrollable
    :width="isMobile ? 'auto' : '490'"
    :fullscreen="isMobile"
    @click:outside="closeDialog"
  >
    <v-card
      id="dialog-template"
      class="dialog-region-select"
    >
      <i
        class="close icon-close"
        @click="closeDialog"
      />
      <v-card-title class="dialog-title">
        信用卡付款
      </v-card-title>
      <v-card-text class="dialog-content">
        <v-progress-circular
          v-if="isLoading"
          indeterminate
          color="primary"
        />
        <section
          v-else
          class="option region-select"
        >
          <v-radio-group
            v-model="selectedCardGuid"
            class="radio-group"
            :mandatory="false"
          >
            <v-radio
              v-for="(card) in cardList"
              :key="card.Guid"
              class="radio"
              :value="card.Guid"
              :disabled="card.isDisabled"
            >
              <div
                slot="label"
                class="item d-flex align-center"
              >
                <img
                  v-if="card.CardAssociation && card.CardAssociation !== 'Unknown'"
                  :src="getCardImage(card.CardAssociation)"
                  class="card-img"
                >
                <p class="mb-0 d-inline pl-2">
                  <span class="pb-0 d-inline">{{ card.IssueBank }}</span>
                  <span class="number pl-1 pb-0 d-inline">****{{ card.LastFour }}</span>
                </p>
              </div>
            </v-radio>
            <v-radio
              class="radio"
              value=""
            >
              <div
                slot="label"
                class="item"
              >
                <p>
                  <span>使用其他信用卡</span>
                </p>
              </div>
            </v-radio>
          </v-radio-group>
        </section>
      </v-card-text>
      <v-card-actions class="dialog-actions">
        <v-btn
          color="primary"
          class="btn"
          depressed
          :loading="submitLoading"
          @click="submit"
        >
          確認
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      required: true
    },
    importSelectedCard: {
      type: Object,
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      dialogOpen: false,
      cardList: [],
      selectedCardGuid: ''
    }
  },
  computed: {
    selectedCard () {
      return this.cardList.find(card => card.Guid === this.selectedCardGuid) || null
    },
    isMobile () {
      return this.$store.getters.isMobile
    }
  },
  watch: {
    async open (val) {
      this.dialogOpen = val
      if (val) {
        if (this.importSelectedCard === undefined) {
          this.setDefaultCard()
        } else {
          await this.initData()
        }
      }
    },
    cardList (val) {
      this.$emit('updateCardList', _.cloneDeep(val)) // 傳遞信用卡列表資料
    }
  },
  async mounted () {
    if (this.importSelectedCard !== undefined) {
      await this.initData()
      this.setDefaultCard()
    }
  },
  methods: {
    setDefaultCard () {
      if (!Array.isArray(this.cardList) || this.cardList.length === 0) {
        this.$emit('updateSelectedCard', null)
        return;
      }
      const defaultCard = this.cardList.filter(card => card.IsDefault)[0] || this.cardList[0]
      this.selectedCardGuid = defaultCard && defaultCard.Guid ? defaultCard.Guid : null
      this.$emit('updateSelectedCard', _.cloneDeep(this.selectedCard))
    },
    async initData () {
      this.isLoading = true
      try {
        const { data } = await this.$axios.get('/api/Card/Cards')
        if (data.Status === 1) {
          this.cardList = data.Data.Cards
          // 取得外部傳入的選擇信用卡資料
          if (this.importSelectedCard) {
            const selectedCard = this.cardList.find(card => card.Guid === this.importSelectedCard.Guid)
            if (selectedCard) {
              this.selectedCardGuid = selectedCard.Guid
            } else {
              this.selectedCardGuid = ''
            }
          }
          if (!this.importSelectedCard && this.importSelectedCard !== undefined) {
            this.selectedCardGuid = ''
          }
        }
        this.isLoading = false
        return data
      } catch (error) {
        console.error(error)
        this.isLoading = false
        this.cardList = []
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '取得信用卡資料失敗',
          type: 'error'
        })
        return null
      }
    },
    closeDialog () {
      this.$emit('close')
    },
    submit () {
      this.$emit('creditCardSubmit', _.cloneDeep(this.selectedCard))
    },
    getCardImage(cardAssociation) {
      if (typeof cardAssociation !== 'string') return
      const imageName = cardAssociation.trim().toLowerCase().replace(/\s/g, '-')
      return require(`@/assets/image/payment/${imageName}.svg`);
    }
  }
}
</script>

<style lang="scss" scoped>
#dialog-template {
  height: 580px;
  max-height: 90vh;
  .dialog-content {
    min-height: 0;
    .radio-group {
      .v-radio.radio {
        border: 0;
        margin-bottom: 14px;
      }
      .v-label {
        font-size: pxTorem(15px);
        p {
          color: $fontColor;
        }
        .number {
          color: $midGrayColor;
        }
      }
    }
  }
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  #dialog-template {
    height: auto;
    max-height: 100%;
    .dialog-content {
      border-top: 0;
      padding-top: 10px;
    }
    .dialog-actions {
      border-top: 1px solid $midGrayColor;
      .btn {
        width: 100%;
      }
    }
  }
}
</style>
